import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useEducationAuth } from '../../../contexts/EducationAuthContext';

// /admin → Founder Console home (signed-in admins) or the real sign-in page.
export default function AdminEntryRedirect() {
  const { user, loading } = useEducationAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  if (user?.role === 'shs_admin') return <Navigate to="/admin/home" replace />;
  return <Navigate to="/education/login" replace state={{ from: '/admin/home' }} />;
}
